import React, { useState, useEffect } from 'react';
import './index.scss';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Start Now": "Start Now",
        "Talk and Korean Learn": "Talk and Korean Learn",
        "Weekend or weekday,": "Weekend or weekday,",
        "learn Korean right from your fingertips.": "learn Korean right from your fingertips.",
        "24 Hours": "24 Hours",
        "Anytime": "Anytime",
        "Learn with 20+ AI Mates": "Learn with 20+ AI Mates",
        "AI Mate is always ready to help you with friendly explanations.": "AI Mate is always ready to help you with friendly explanations.",
        "Improve your pronunciation": "Improve your pronunciation",
        "Pronunciation practice made easy with voice chat": "Pronunciation practice made easy with voice chat",
        "No need to worry about difficult pronunciation—hear examples from native speakers anytime.": "No need to worry about difficult pronunciation—hear examples from native speakers anytime.",
        "Study Buddy": "Study Buddy",
        "Join 30,000+ other learners": "Join 30,000+ other learners",
        "Share information about learning Korean with your community friends": "Share information about learning Korean with your community friends",
        "The Right Korean Teacher for You": "The Right Korean Teacher for You",
        "Start learning without confusion": "Start learning without confusion",
        "Our curriculum helps you know where to start and what to learn first.": "Our curriculum helps you know where to start and what to learn first.",
        "Latest Korean News": "Latest Korean News",
        "Learn Korean while reading the latest news from Korea": "Learn Korean while reading the latest news from Korea",
        "Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.": "Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.",
        "From everyday conversations to romantic chats,": "From everyday conversations to romantic chats,",
        "Mate can be your Korean friend!": "Mate can be your Korean friend!",
        "Voice Chat": "Voice Chat",
        "Talk in real-time using push-to-talk method.": "Talk in real-time using push-to-talk method.",
        "Smarter Chat Mode": "Smarter Chat Mode",
        "Experience enhanced performance and smarter conversations in an upgraded chat mode.": "Experience enhanced performance and smarter conversations in an upgraded chat mode.",
        "Meet various unique AI characters that keep growing over time.": "Meet various unique AI characters that keep growing over time.",
        "Through Mate Curriculum,": "Through Mate Curriculum,",
        "You Can Start an Exciting Adventure Learning Korean": "You Can Start an Exciting Adventure Learning Korean",
        "Personalization for All Levels": "Personalization for All Levels",
        "From sharing interests to making new friends,": "From sharing interests to making new friends,",
        "Korea's #1 Cultural Community": "Korea's #1 Cultural Community",
        "Ready to": "Ready to",
        "Talk and Learn Korean?": "Talk and Learn Korean?",
        "learn Korean with Mate": "learn Korean with Mate",
        "All rights reserved.": "All rights reserved."
    },
    id: {
        "Start Now": "Mulai Langsung",
        "Talk and Korean Learn": "Talk and Korean Learn",
        "Weekend or weekday,": "Weekend atau weekday,",
        "learn Korean right from your fingertips.": "belajar Bahasa Korea langsung dari ujung jari.",
        "24 Hours": "24 Jam",
        "Anytime": "Kapan Saja",
        "Learn with 20+ AI Mates": "Belajar dengan 20+ AI Mate",
        "AI Mate is always ready to help you with friendly explanations.": "AI Mate selalu siap bantu kamu dengan penjelasan yang ramah.",
        "Improve your pronunciation": "Benahi pelafalanmu",
        "Pronunciation practice made easy with voice chat": "Latihan pengucapan jadi mudah lewat voice chat",
        "No need to worry about difficult pronunciation—hear examples from native speakers anytime.": "Nggak perlu khawatir soal pelafalan sulit—dengar contoh dari penutur asli kapan saja.",
        "Study Buddy": "Teman Belajar",
        "Join 30,000+ other learners": "Bergabung dengan 30.000+ pelajar lainnya",
        "Share information about learning Korean with your community friends": "Bagikan info soal belajar bahasa Korea bersama teman komunitasmu",
        "The Right Korean Teacher for You": "Guru Bahasa Korea yang Tepat Untukmu",
        "Start learning without confusion": "Mulai belajar tanpa bingung",
        "Our curriculum helps you know where to start and what to learn first.": "Kurikulum kami bantu kamu tahu harus mulai dari mana dan belajar apa dulu.",
        "Latest Korean News": "Berita Korea Terkini",
        "Learn Korean while reading the latest news from Korea": "Belajar bahasa Korea sambil membaca berita terbaru dari Korea",
        "Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.": "Hiburan, olahraga, kesehatan, dan banyak lagi. Satu tempat untuk belajar sekaligus update berita Korea.",
        "From everyday conversations to romantic chats,": "Dari obrolan sehari-hari hingga percakapan romantis,",
        "Mate can be your Korean friend!": "Mate bisa menjadi teman Koreamu!",
        "Voice Chat": "Voice Chat",
        "Talk in real-time using push-to-talk method.": "Bisa berbicara secara real-time dengan menggunakan metode push-to-talk.",
        "Smarter Chat Mode": "Mode Chat Lebih Canggih",
        "Experience enhanced performance and smarter conversations in an upgraded chat mode.": "Experience enhanced performance and smarter conversations in an upgraded chat mode.",
        "Meet various unique AI characters that keep growing over time.": "Temui berbagai karakter AI unik yang terus bertambah setiap waktu.",
        "Through Mate Curriculum,": "Melalui Kurikulum Mate,",
        "You Can Start an Exciting Adventure Learning Korean": "Kamu Bisa Memulai Petualangan Seru Belajar Bahasa Korea",
        "Personalization for All Levels": "Personalisasi untuk Semua Level",
        "From sharing interests to making new friends,": "Berbagi Minat hingga Menambah Teman Baru,",
        "Korea's #1 Cultural Community": "Komunitas Budaya Korea No.1",
        "Ready to": "Ready to",
        "Talk and Learn Korean?": "Talk and Learn Korean?",
        "learn Korean with Mate": "learn Korean with Mate",
        "All rights reserved.": "All rights reserved."
    },
    ko: {
        "Start Now": "지금 시작하기",
        "Talk and Korean Learn": "Talk and Korean Learn",
        "Weekend or weekday,": "주말이든 평일이든,",
        "learn Korean right from your fingertips.": "손끝으로 바로 한국어를 배워보세요.",
        "24 Hours": "24시간",
        "Anytime": "언제든지",
        "Learn with 20+ AI Mates": "20개 이상의 AI Mate와 함께 배우기",
        "AI Mate is always ready to help you with friendly explanations.": "AI Mate가 친절한 설명으로 항상 도와드립니다.",
        "Improve your pronunciation": "발음 교정하기",
        "Pronunciation practice made easy with voice chat": "음성 채팅으로 쉽게 발음 연습",
        "No need to worry about difficult pronunciation—hear examples from native speakers anytime.": "어려운 발음 걱정 없이 언제든 원어민의 예시를 들어보세요.",
        "Study Buddy": "학습 친구",
        "Join 30,000+ other learners": "30,000명 이상의 학습자와 함께하세요",
        "Share information about learning Korean with your community friends": "커뮤니티 친구들과 한국어 학습 정보를 공유하세요",
        "The Right Korean Teacher for You": "당신에게 딱 맞는 한국어 선생님",
        "Start learning without confusion": "혼란 없이 학습 시작하기",
        "Our curriculum helps you know where to start and what to learn first.": "커리큘럼이 어디서 시작하고 무엇을 먼저 배워야 하는지 알려드립니다.",
        "Latest Korean News": "최신 한국 뉴스",
        "Learn Korean while reading the latest news from Korea": "한국의 최신 뉴스를 읽으며 한국어 배우기",
        "Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.": "엔터테인먼트, 스포츠, 건강 등. 한국 뉴스를 배우고 업데이트하는 한 곳.",
        "From everyday conversations to romantic chats,": "일상 대화부터 로맨틱한 대화까지,",
        "Mate can be your Korean friend!": "Mate가 당신의 한국인 친구가 될 수 있어요!",
        "Voice Chat": "음성 채팅",
        "Talk in real-time using push-to-talk method.": "푸시 투 토크 방식으로 실시간 대화하세요.",
        "Smarter Chat Mode": "더 스마트한 채팅 모드",
        "Experience enhanced performance and smarter conversations in an upgraded chat mode.": "업그레이드된 채팅 모드에서 향상된 성능과 더 스마트한 대화를 경험하세요.",
        "Meet various unique AI characters that keep growing over time.": "계속해서 늘어나는 다양한 고유 AI 캐릭터를 만나보세요.",
        "Through Mate Curriculum,": "Mate 커리큘럼을 통해,",
        "You Can Start an Exciting Adventure Learning Korean": "신나는 한국어 학습 모험을 시작할 수 있어요",
        "Personalization for All Levels": "모든 레벨을 위한 맞춤화",
        "From sharing interests to making new friends,": "관심사 공유부터 새 친구 사귀기까지,",
        "Korea's #1 Cultural Community": "한국 문화 커뮤니티 1위",
        "Ready to": "Ready to",
        "Talk and Learn Korean?": "Talk and Learn Korean?",
        "learn Korean with Mate": "learn Korean with Mate",
        "All rights reserved.": "All rights reserved."
    },
    vn: {
        "Start Now": "Bắt đầu ngay",
        "Talk and Korean Learn": "Talk and Korean Learn",
        "Weekend or weekday,": "Cuối tuần hay ngày thường,",
        "learn Korean right from your fingertips.": "học tiếng Hàn ngay từ đầu ngón tay.",
        "24 Hours": "24 Giờ",
        "Anytime": "Bất cứ lúc nào",
        "Learn with 20+ AI Mates": "Học với hơn 20 AI Mate",
        "AI Mate is always ready to help you with friendly explanations.": "AI Mate luôn sẵn sàng giúp bạn với những giải thích thân thiện.",
        "Improve your pronunciation": "Cải thiện phát âm của bạn",
        "Pronunciation practice made easy with voice chat": "Luyện phát âm dễ dàng với trò chuyện giọng nói",
        "No need to worry about difficult pronunciation—hear examples from native speakers anytime.": "Không cần lo lắng về phát âm khó—nghe ví dụ từ người bản ngữ bất cứ lúc nào.",
        "Study Buddy": "Bạn học",
        "Join 30,000+ other learners": "Tham gia cùng hơn 30.000 người học khác",
        "Share information about learning Korean with your community friends": "Chia sẻ thông tin về việc học tiếng Hàn với bạn bè cộng đồng",
        "The Right Korean Teacher for You": "Giáo viên tiếng Hàn phù hợp với bạn",
        "Start learning without confusion": "Bắt đầu học mà không bối rối",
        "Our curriculum helps you know where to start and what to learn first.": "Chương trình học giúp bạn biết bắt đầu từ đâu và học gì trước.",
        "Latest Korean News": "Tin tức Hàn Quốc mới nhất",
        "Learn Korean while reading the latest news from Korea": "Học tiếng Hàn trong khi đọc tin tức mới nhất từ Hàn Quốc",
        "Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.": "Giải trí, thể thao, sức khỏe và nhiều hơn nữa. Một nơi để học và cập nhật tin tức Hàn Quốc.",
        "From everyday conversations to romantic chats,": "Từ cuộc trò chuyện hàng ngày đến những cuộc trò chuyện lãng mạn,",
        "Mate can be your Korean friend!": "Mate có thể là người bạn Hàn Quốc của bạn!",
        "Voice Chat": "Trò chuyện giọng nói",
        "Talk in real-time using push-to-talk method.": "Nói chuyện theo thời gian thực bằng phương pháp push-to-talk.",
        "Smarter Chat Mode": "Chế độ trò chuyện thông minh hơn",
        "Experience enhanced performance and smarter conversations in an upgraded chat mode.": "Trải nghiệm hiệu suất nâng cao và cuộc trò chuyện thông minh hơn trong chế độ trò chuyện nâng cấp.",
        "Meet various unique AI characters that keep growing over time.": "Gặp gỡ các nhân vật AI độc đáo đa dạng liên tục phát triển theo thời gian.",
        "Through Mate Curriculum,": "Thông qua chương trình Mate,",
        "You Can Start an Exciting Adventure Learning Korean": "Bạn có thể bắt đầu cuộc phiêu lưu học tiếng Hàn thú vị",
        "Personalization for All Levels": "Cá nhân hóa cho mọi cấp độ",
        "From sharing interests to making new friends,": "Từ chia sẻ sở thích đến kết bạn mới,",
        "Korea's #1 Cultural Community": "Cộng đồng văn hóa Hàn Quốc số 1",
        "Ready to": "Ready to",
        "Talk and Learn Korean?": "Talk and Learn Korean?",
        "learn Korean with Mate": "learn Korean with Mate",
        "All rights reserved.": "All rights reserved."
    }
};

function LandingPage() {
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    const destination = 'https://koreanmate.onelink.me/Tkco/y94asact';
    const heroImages = ['/img/hero1.jpg', '/img/hero2.jpg', '/img/hero3.jpg', '/img/hero4.jpg', '/img/hero5.jpg'];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handlePrevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? heroImages.length - 1 : prev - 1));
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prev) => (prev === heroImages.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="LandingPage">
            <div className="LandingContainer">
                {/* Top Background Wrapper */}
                <div className="TopBackgroundWrapper">
                    {/* Hero Wrapper */}
                    <div className="HeroWrapper" style={{
                        backgroundImage: 'url(/img/herobg.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    {/* Top Section */}
                    <section className="TopSection">
                    <div className="TopInner">
                        {/* Header */}
                        <div className="HeaderRow">
                            <div className="HeaderLeft">
                                <div className="LogoWrapper">
                                    <img src="/svg/landinglogo.png" alt="MATE Logo" />
                                </div>
                                <div className="HeaderTextWrapper">
                                    <p>{t("Talk and Korean Learn")}</p>
                                </div>
                            </div>
                            <div className="HeaderRight">
                                <div className="TitleWrapper">
                                    <p>MATE</p>
                                </div>
                            </div>
                        </div>

                        {/* Hero Image */}
                        <div className="HeroImageSection">
                            <div className="HeroImageBox">
                                <img src={heroImages[currentImageIndex]} alt="Hero" />
                            </div>
                        </div>
                    </div>

                    {/* Controls */}
                    <div className="ControlsRow">
                        <div className="ControlButton" onClick={handlePrevImage} style={{ cursor: 'pointer' }}>
                            <div className="ControlCircle">
                                <img src="/img/arrowleft.svg" alt="Previous" />
                            </div>
                        </div>
                        <div className="ControlButton" onClick={handleNextImage} style={{ cursor: 'pointer' }}>
                            <div className="ControlCircle">
                                <img src="/img/arrowright.svg" alt="Next" />
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <button className="CTAButton" onClick={() => window.open(destination, "_blank")}>
                        <p>{t("Start Now")}</p>
                        <div className="CTAIcon">
                            <img src="/svg/icon_arrow.svg" alt="Arrow" />
                        </div>
                    </button>
                    </section>

                    {/* Features Section */}
                    <section className="FeaturesSection">
                    <div className="FeaturesSectionInner">
                        <div className="FeaturesTitle">
                            <p>{t("Weekend or weekday,")}</p>
                            <p>{t("learn Korean right from your fingertips.")}</p>
                        </div>
                        <div className="FeaturesGrid">
                            {/* Card 1 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Sparkels.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>{t("24 Hours")}</p>
                                        <p>{t("Anytime")}</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">{t("Learn with 20+ AI Mates")}</p>
                                    <p className="CardLight">{t("AI Mate is always ready to help you with friendly explanations.")}</p>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/heart-rate.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>{t("Improve your pronunciation")}</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">{t("Pronunciation practice made easy with voice chat")}</p>
                                    <p className="CardLight">{t("No need to worry about difficult pronunciation—hear examples from native speakers anytime.")}</p>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Users_3.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>{t("Study Buddy")}</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">{t("Join 30,000+ other learners")}</p>
                                    <p className="CardLight">{t("Share information about learning Korean with your community friends")}</p>
                                </div>
                            </div>

                            {/* Card 4 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/list_check.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>{t("The Right Korean Teacher for You")}</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">{t("Start learning without confusion")}</p>
                                    <p className="CardLight">{t("Our curriculum helps you know where to start and what to learn first.")}</p>
                                </div>
                            </div>

                            {/* Card 5 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Notes-lines-alt.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>{t("Latest Korean News")}</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">{t("Learn Korean while reading the latest news from Korea")}</p>
                                    <p className="CardLight">{t("Entertainment, sports, health, and more. One place to learn and stay updated on Korean news.")}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <button className="CTAButton" onClick={() => window.open(destination, "_blank")}>
                        <p>{t("Start Now")}</p>
                        <div className="CTAIcon">
                            <img src="/svg/icon_arrow.svg" alt="Arrow" />
                        </div>
                    </button>
                    </section>
                    </div>

                </div>

                {/* AI Mate Section */}
                <section className="AIMateSection">
                    {/* Wave Divider */}
                    <section className="WaveDivider">
                        <div className="WaveWrapper">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG" />
                        </div>
                    </section>

                    <div className="Inner">
                        <div className="Header">
                            <div className="Badge">
                                <p>AI Mate</p>
                            </div>
                            <div className="Title">
                                <p>{t("From everyday conversations to romantic chats,")}</p>
                                <p>{t("Mate can be your Korean friend!")}</p>
                            </div>
                        </div>

                        <div className="CardsWrapper">
                            <div className="Cards">
                                {/* Card 1 */}
                                <div className="Card">
                                    <div className="Image">
                                        <img src="/img/aichatimg1.png" alt="Voice Chat" />
                                    </div>
                                    <div className="Overlay">
                                        <p className="Title">{t("Voice Chat")}</p>
                                        <p className="Description">{t("Talk in real-time using push-to-talk method.")}</p>
                                    </div>
                                </div>

                                {/* Card 2 */}
                                <div className="Card">
                                    <div className="Image">
                                        <img src="/img/aichatimg2.png" alt="Chat Mode" />
                                    </div>
                                    <div className="Overlay">
                                        <p className="Title">{t("Smarter Chat Mode")}</p>
                                        <p className="Description">{t("Experience enhanced performance and smarter conversations in an upgraded chat mode.")}</p>
                                    </div>
                                </div>

                                {/* Card 3 */}
                                <div className="Card">
                                    <div className="Image">
                                        <img src="/img/aichatimg3.png" alt="Chat Mode" />
                                    </div>
                                    <div className="Overlay">
                                        <p className="Title">20 + AI Mate</p>
                                        <p className="Description">{t("Meet various unique AI characters that keep growing over time.")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <div className="CTA">
                        <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                            <p>{t("Start Now")}</p>
                            <div className="CTAIcon">
                                <img src="/svg/icon_arrow.svg" alt="Arrow" />
                            </div>
                        </button>
                    </div>
                </section>

                {/* Curriculum Wrapper with Background */}
                <div className="CurriculumWrapper">
                    {/* Wave Divider 1 */}
                    <section className="WaveDivider1">
                        <div className="WaveWrapper1">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG1" />
                        </div>
                    </section>

                    {/* Curriculum Section */}
                    <section className="CurriculumSection" style={{
                        backgroundImage: 'url(/img/wavebg.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    <div className="CurriculumInner">
                        <div className="CurriculumBadge">
                            <p>Mate Curriculum</p>
                        </div>
                        <div className="CurriculumTitle">
                            <p>{t("Through Mate Curriculum,")}</p>
                            <p> {t("You Can Start an Exciting Adventure Learning Korean")}</p>
                        </div>
                        <div className="CurriculumContent">
                            <div className="CurriculumMapWrapper">
                                <div className="CurriculumMap">
                                    <img src="/img/landingmap.png" alt="Korean Island Map" />
                                </div>
                            </div>
                            <p className="CurriculumSubtitle">{t("Personalization for All Levels")}</p>
                        </div>
                        <div className="CurriculumCTA">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>{t("Start Now")}</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>
                    </section>

                    {/* Wave Divider 2 */}
                    <section className="WaveDivider2">
                        <div className="WaveWrapper2">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG2" />
                        </div>
                    </section>
                </div>

                {/* Community Section */}
                <section className="CommunitySection">
                    <div className="CommunityInner">
                        <div className="CommunityHeader">
                            <div className="CommunityBadge">
                                <p>Mate Community</p>
                            </div>
                            <div className="CommunityTitle">
                                <p>{t("From sharing interests to making new friends,")}</p>
                                <p>{t("Korea's #1 Cultural Community")}</p>
                            </div>
                        </div>
                        <div className="CommunityContent">
                            <div className="CommunityWorld">
                                <img src="/img/landingworld.jpg" alt="World Community" />
                            </div>
                        </div>
                        <div className="CommunityCTA">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>{t("Start Now")}</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>

                    {/* Wave Divider 3 */}
                    <section className="WaveDivider3">
                        <div className="WaveWrapper3">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG3" />
                        </div>
                    </section>
                </section>

                {/* Final CTA Section */}
                <section className="FinalCTASection">
                    <div className="FinalCTAInner">
                        <div className="FinalCTAHeader">
                            <div className="FinalCTALogo">
                                <img src="/svg/landinglogo.png" alt="Mate Logo" />
                            </div>
                            <div className="FinalCTATitle">
                                <p>{t("Ready to")}</p>
                                <p>{t("Talk and Learn Korean?")}</p>
                            </div>
                        </div>
                        <div className="FinalCTAButton">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>{t("Start Now")}</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="Footer">
                    <div className="FooterInner">
                        <div className="FooterBrand">
                            <div className="FooterLogo">
                                <img src="/svg/matelogo 2.svg" alt="Mate Logo" />
                                <p>MATE</p>
                            </div>
                            <p className="FooterTagline">{t("learn Korean with Mate")}</p>
                        </div>
                        <div className="FooterContent">
                            <div className="FooterInfo">
                                <div className="FooterCompany">
                                    <p><span>indonesia</span> | <span className="FooterBold">KOREAN CULTURE MATE</span></p>
                                    <p><span>korea</span> | <span className="FooterBold">WEBTOON TODAY</span></p>
                                </div>
                                <p className="FooterRights">{t("All rights reserved.")}</p>
                                <div className="FooterAddress">
                                    <div className="FooterAddressIcon">
                                        <img src="/svg/location.svg" alt="Location" />
                                    </div>
                                    <div className="FooterAddressText">
                                        <p>Bellezza office Tower,</p>
                                        <p>Jakarta Selatan 12210, Indonesia</p>
                                    </div>
                                </div>
                                <p className="FooterCopyright">©2025 WEBTOON TODAY</p>
                            </div>
                            <div className="FooterSocial">
                                <img src="/svg/Social Icons.svg" alt="Twitter" />
                                <img src="/svg/Social Icons-1.svg" alt="Instagram" />
                                <img src="/svg/Social Icons-2.svg" alt="WhatsApp" />
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default LandingPage;
